import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetCreateVarianteController::__invoke
* @see app/Http/Controllers/Item/GetCreateVarianteController.php
* @route '/api/item-new-variant/{item}'
*/
const GetCreateVarianteController = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: GetCreateVarianteController.url(args, options),
    method: 'put',
})

GetCreateVarianteController.definition = {
    methods: ["put"],
    url: '/api/item-new-variant/{item}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Item\GetCreateVarianteController::__invoke
* @see app/Http/Controllers/Item/GetCreateVarianteController.php
* @route '/api/item-new-variant/{item}'
*/
GetCreateVarianteController.url = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
    }

    return GetCreateVarianteController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetCreateVarianteController::__invoke
* @see app/Http/Controllers/Item/GetCreateVarianteController.php
* @route '/api/item-new-variant/{item}'
*/
GetCreateVarianteController.put = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: GetCreateVarianteController.url(args, options),
    method: 'put',
})

export default GetCreateVarianteController